import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import styled from '@emotion/styled'

import { TruncateAndTooltip } from 'mailup-web-components'

import { calendarDayState } from 'Pages/ScheduledSendings/recoil/state/calendar'
import { selectDayCallback } from 'Pages/ScheduledSendings/recoil/callbacks/callbacks'

const StyledMore = styled.div`
  display: inline-block;
  margin-left: 5px;
  background-color: var(--java);
  color: white;
  font-family: 'Roboto Condensed', arial, sans-serif;
  line-height: 1em;
  font-size: 12px;
  letter-spacing: 1px;
  padding: 2px 6px 3px;
  border-radius: 10px;
  transition: background-color 0.2s ease 0s, color 0.2s ease 0s;
  cursor: pointer;
  margin: 1px 3px;
  text-decoration: none;
  box-sizing: content-box;
`

const StyledSendingItem = styled.a`
  background-color: rgb(235, 248, 241) !important;
  margin: 0px 2px 2px;
  padding: 1px 4px 3px;
  border-width: initial;
  border-style: none;
  border-color: initial;
  border-image: initial;
  transition: background-color 0.2s ease-in-out 0s;

  box-sizing: content-box;

  color: var(--pure-white);
  text-decoration: none;

  position: relative;
  display: block;
  font-size: 0.85em;
  line-height: 1.3;
  font-weight: normal;
  border-radius: 3px;

  &:hover {
    background-color: rgb(205, 236, 221) !important;
  }
`

const StyledSendingItemContent = styled.div`
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  z-index: 2;
  border-color: white;
  box-sizing: content-box;
`

const StyledSendingItemTime = styled.div`
  font-family: 'Roboto Condensed', arial, sans-serif;
  color: rgb(57, 186, 124);
  font-weight: 500;
`

const StyledSentingItemTitle = styled.div`
  display: flex;
  align-items: center;
`

const StyledSentingItemTitleDescr = styled.div`
  color: var(--boulder);
  font-family: 'Roboto Condensed', arial, sans-serif;
  line-height: 1.2em;
  flex: 0 0 80%;
  max-width: 80%;
`

const StyledSentingItemList = styled.div`
  color: rgb(160, 160, 160);
  font-family: 'Roboto Condensed', arial, sans-serif;
  line-height: 1.2em;
  text-align: right;
  flex: 0 0 20%;
`

const SendingItem = ({ timeFormatted, title, idList, dateFormatted, id }) => {
  const selectDay = useRecoilCallback(selectDayCallback, [])
  const handleClick = e => {
    e.stopPropagation()
    selectDay(dateFormatted, id)
  }

  return (
    <StyledSendingItem onClick={handleClick}>
      <StyledSendingItemContent>
        <StyledSendingItemTime>{timeFormatted}</StyledSendingItemTime>
        <StyledSentingItemTitle>
          <StyledSentingItemTitleDescr>
            <TruncateAndTooltip text={title} />
          </StyledSentingItemTitleDescr>
          <StyledSentingItemList>{idList}</StyledSentingItemList>
        </StyledSentingItemTitle>
      </StyledSendingItemContent>
    </StyledSendingItem>
  )
}

SendingItem.propTypes = {
  timeFormatted: PropTypes.string,
  dateFormatted: PropTypes.string,
  title: PropTypes.string,
  idList: PropTypes.number,
  id: PropTypes.number
}

const CalendarDayContent = ({ date }) => {
  const intl = useIntl()
  const { sendings, more } = useRecoilValue(calendarDayState(date))

  return sendings.length ? (
    <>
      {sendings.map(s => (
        <SendingItem key={s.id} {...s} />
      ))}
      {more > 0 && <StyledMore>+{intl.formatNumber(more)}</StyledMore>}
    </>
  ) : null
}

CalendarDayContent.propTypes = {
  date: PropTypes.string
}

export default CalendarDayContent
